import React, { Component } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { Drawer, Button, Table, Row, Col } from 'components/ui';
import { ConfirmDelete, Loading } from 'components/blocks';
import { showErrorNotification } from 'services/common';
import CreateWebhook from './CreateWebhook';
import './style.css';

class ListWebhooks extends Component {
  state = {
    activeWebhookId: -1,
    showConfirmDeleteModal: false,
    showCreateWebhookModal: false,
  };

  componentDidUpdate(prevProps) {
    this.showErrors(prevProps);
  }

  showErrors = prevProps => {
    if (this.props.error && prevProps.error !== this.props.error) {
      showErrorNotification(this.props.error);
    }
  };

  handleDeleteWebhook = event => {
    let { id } = event.target;
    id = Number(id.replace('delete-', ''));
    this.setState({
      activeWebhookId: id,
      showConfirmDeleteModal: true,
    });
  };

  handleShowCreateWebhookModal = () => {
    this.setState({ showCreateWebhookModal: true });
  };

  handleHideCreateWebhookModal = () => {
    this.setState({ showCreateWebhookModal: false });
  };

  handleHideConfirmDelete = () => {
    this.setState({ showConfirmDeleteModal: false });
  };

  handleConfirmDeleteWebhook = () => {
    this.props.onDeleteWebhook(this.state.activeWebhookId);
    this.handleHideConfirmDelete();
  };

  handleClose = () => {
    this.props.onHide();
  };

  getActiveWebhook = () => {
    const { webhooks } = this.props;
    const activeWebhookId = Number(this.state.activeWebhookId);
    return find(webhooks, { id: activeWebhookId }) || {};
  };

  getTableColumns = () => [
    {
      title: 'Event',
      dataIndex: 'event',
      key: 'event',
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
    },
    {
      title: 'Api Key',
      dataIndex: 'api_key',
      key: 'api_key',
      width: 200,
    },
    {
      title: 'actions',
      render: ({ key }) => (
        <Button
          className="webhooks__delete-btn"
          id={`delete-${key}`}
          type="button"
          onClick={this.handleDeleteWebhook}
        >
          Delete
        </Button>
      ),
    },
  ];

  getTableData = () =>
    this.props.webhooks
      .filter(webhook => webhook.template_id === this.props.template.id)
      .map(webhook => ({
        key: webhook.id,
        event: webhook.event,
        url: webhook.url,
        actions: webhook.id,
        api_key: webhook.api_key
          ? `${webhook.api_key_header_name || 'api-key'}:xxxx`
          : '',
      }));

  getDrawerWidth = () => Math.floor(window.innerWidth * 0.8);

  render() {
    const { isVisible, isLoading, template } = this.props;
    const { showCreateWebhookModal, showConfirmDeleteModal } = this.state;
    const activeWebhook = this.getActiveWebhook();

    return (
      <Drawer
        placement="right"
        title={`${template.name} Webhooks`}
        visible={isVisible}
        width={Math.floor(window.innerWidth * 0.9)}
        onClose={this.handleClose}
      >
        <div className="webhooks">
          <Row className="webhooks__header">
            <Col className="webhooks__title" span={12}>
              <h1>Webhooks </h1>
              {isLoading && <Loading />}
            </Col>
            <Col span={12}>
              <Button
                className="webhooks__create-Webhook-btn"
                onClick={this.handleShowCreateWebhookModal}
              >
                Create new Webhook
              </Button>
            </Col>
          </Row>
          <Table
            columns={this.getTableColumns()}
            dataSource={this.getTableData()}
          />
          <CreateWebhook
            isVisible={showCreateWebhookModal}
            templateId={template.id}
            onHide={this.handleHideCreateWebhookModal}
          />
          <ConfirmDelete
            description={`You are about to delete a ${activeWebhook.event} Webhook to '${activeWebhook.url}'. Do you wish to proceed?`}
            isVisible={showConfirmDeleteModal}
            title={`Delete ${activeWebhook.event} Webhook?`}
            onConfirm={this.handleConfirmDeleteWebhook}
            onHide={this.handleHideConfirmDelete}
          />
        </div>
      </Drawer>
    );
  }
}

ListWebhooks.defaultProps = {
  webhooks: [],
  error: '',
  isLoading: false,
  template: {},
};

ListWebhooks.propTypes = {
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isVisible: PropTypes.bool.isRequired,
  template: PropTypes.object,
  webhooks: PropTypes.array,
  onDeleteWebhook: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ListWebhooks;
